import { render, staticRenderFns } from "./JSControl.vue?vue&type=template&id=248b8621"
import script from "./JSControl.vue?vue&type=script&lang=js"
export * from "./JSControl.vue?vue&type=script&lang=js"
import style0 from "./JSControl.vue?vue&type=style&index=0&id=248b8621&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports